<template>
  <div class="d-flex align-center gap-2">
    <v-switch
      v-model="publishedToWeb"
      label="Published to web"
      :disabled="!isEditAllowed"
      hide-details
      class="mt-0 pt-0"
    />
    <v-tooltip v-if="!isEditAllowed" location="bottom">
      <template #activator="{ props }">
        <v-icon v-bind="props" class="cursor-pointer">
          mdi-information-outline
        </v-icon>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { useUserRoles } from '@/bundles/App/composables/useUserRoles';
export default defineComponent({
  name: 'ContactPublishToWebSwitch',

  props: {
    modelValue: Boolean,
    isInternal: Boolean,
  },

  emits: ['update:modelValue'],

  setup () {
    const { isAdmin } = useUserRoles();

    return { isAdmin };
  },

  computed: {
    publishedToWeb: {
      get (): boolean {
        return this.modelValue;
      },
      set (value: boolean) {
        this.$emit('update:modelValue', value)
      }
    },
    isEditAllowed (): boolean {
      // @ts-ignore
      return this.isAdmin && this.isInternal;
    },
    tooltipText (): string {
      // @ts-ignore
      if (!this.isAdmin) {
        return 'You are not an admin and cannot publish contacts to the web.';
      }

      if (!this.isInternal) {
        return 'This contact is not internal and cannot be published to the web.';
      }

      return '';
    }
  }
})
</script>
